import { UserRole } from "@prisma/client";

export interface PhoneVerificationResult {
  success: boolean;
  phone: string;
  verifiedAt: Date;
  userId?: string;
  isNewUser: boolean;
}

export interface UserUpsertResult {
  user: {
    id: string;
    phone: string;
    phoneVerified: Date;
    isSetupComplete: boolean;
    setupSteps: string[];
    role: UserRole;
  };
  isNewUser: boolean;
  session: {
    token: string;
    expiresAt: Date;
  };
}

export enum SetupStep {
  PHONE_VERIFIED = "phone_verified",
  EMAIL_VERIFIED = "email_verified",
  BASIC_PROFILE = "basic_profile",
  PREFERENCES = "preferences",
  NOTIFICATIONS = "notifications",
  OPTIONAL_PROFILE = "optional_profile",
  TERMS_OF_SERVICE = "terms_of_service"
}

export const REQUIRED_SETUP_STEPS: SetupStep[] = [
  SetupStep.BASIC_PROFILE,
  SetupStep.TERMS_OF_SERVICE,
]

export interface SetupStepStatus {
  id: SetupStep;
  completed: boolean;
  required: boolean;
  order: number;
}

export interface SetupProgress {
  isComplete: boolean;
  currentStep: SetupStep;
  steps: SetupStepStatus[];
  userId: string;
}
